import { tagMap } from '@/utils/constants'
import { serverSidePropsFor } from '@/utils/helpers.server'

import CommandersPage from '.'

export const getServerSideProps = async (context: any) => {
  const dir = context.resolvedUrl.startsWith('/cards') ? 'cards' : 'commanders'

  let url
  if (context.query.f && context.params?.slug) {
    // Deck filters
    const params = {
      cmdr: context.query.slug[0],
      dir: 'commanders',
      f: context.query.f,
    }
    const queryString = new URLSearchParams(params).toString()
    url = `${process.env.NEXT_PUBLIC_EDHREC_API_URL}/filters/?${queryString}`
  } else {
    const cardName = context.query.slug[0]
    const subDirs = context.query.slug
      .slice(1)
      .map((slug: string) => (slug in tagMap ? tagMap[slug as keyof typeof tagMap] : slug))
    const resolvedUrl = subDirs.length > 0 ? `${cardName}/${subDirs.join('/')}` : cardName
    url = `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/${dir}/${resolvedUrl}.json`
  }

  return serverSidePropsFor(url)
}

export default CommandersPage
